import React from 'react';
import {Link} from 'react-router-dom';

// TODO: Rewrite as SCSS.
import "./Guide.scss";

export default class Guide extends React.Component {
  render() {
    return (
        <div className="col-12 col-md-9">
            <div className="row no-gutters jumbotron p-5 bg-light">
                <div className="col-12 col-lg-7 order-lg-2 pb-3">
                    <div className="jumbotron-img" />
                </div>
                <div className="col-12 col-lg-5 order-lg-1">
                    <h2>Drawing User Guide</h2>
                    <div className="pb-5">Things you need to know about drawing</div>
                    <Link
                        to="/new"
                        className="btn btn-primary"
                    >Create New Drawing</Link>
                </div>
            </div>
            <div className="row no-gutters p-5">
                <ul className="guide-list">
                    <li className="pb-5">
                        <div className="index">1</div>
                        <h5>Create drawing</h5>
                        <div>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. 
                        </div>
                    </li>
                    <li className="pb-5">
                        <div className="index">2</div>
                        <h5>Create drawing</h5>
                        <div>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. 
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
  }
}
